import { render, staticRenderFns } from "./ServiceTitle.vue?vue&type=template&id=bd9050ac&scoped=true&"
import script from "./ServiceTitle.vue?vue&type=script&lang=js&"
export * from "./ServiceTitle.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTitle.vue?vue&type=style&index=0&id=bd9050ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9050ac",
  null
  
)

export default component.exports